module.exports = __webpack_public_path__ + "images/1-heb458b951ba5a00f8f1b9da45d2f140e.svg";